import {Dispatch} from "redux";
import axios from "axios";
import {
    LogoutDispatchInterface,
    LOGOUT_USER,
} from "../actionTypes/types";
import {generateConfig, refreshTokenHandler} from "../../../utilityFunctions";
import {GlobalError} from "../../../components/errors/GlobalError";
import {UserInfoInterface} from "../../../types";
import {LogoutOperations} from "../../../Helper/LogoutHelper";
import { NavigateFunction } from "react-router-dom";


export const Logout =
    (accessToken: string,
     refreshToken: string,
     userInfo: UserInfoInterface,
     navigate: NavigateFunction) =>
        async (
            dispatch: Dispatch<LogoutDispatchInterface>
        ) => {
            const BASE_URL = process.env.REACT_APP_BASE_URL;
            const config = generateConfig(accessToken);
            try {
                await axios.delete(
                    `${BASE_URL}/api/auth/logout`,
                    config
                );
            } catch (error: any) {
                console.log("here are the error details", error?.response);
                if (error.response?.status === 401) {
                    const refreshedTokens = await refreshTokenHandler(
                        refreshToken,
                        userInfo,
                        dispatch,
                        navigate
                    );
                    const refreshedConfig = generateConfig(refreshedTokens?.accessToken);

                    try {
                        await axios.delete(
                            `${BASE_URL}/api/auth/logout`,
                            refreshedConfig
                        );
                    } catch (error: any) {
                        GlobalError(error);
                    }
                } else {
                    GlobalError(error);
                }
            } finally {   
                LogoutOperations(navigate);
            }

            return dispatch({type: LOGOUT_USER});
        };